import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    feedbacks: [],
    feedbackDetails: {},
    feedbackQuestions: {},
    feedbackQuestionDetails: {},
    refetch: false,
  },
  reducers: {
    setFeedbacks: (state, action) => {
      state.feedbacks = action.payload;
    },
    setFeedbackDetails: (state, action) => {
      state.feedbackDetails = action.payload;
    },
    setFeedbackQuestions: (state, action) => {
      state.feedbackQuestions = action.payload;
    },
    setFeedbackQuestionDetails: (state, action) => {
      state.feedbackQuestionDetails = action.payload;
    },
    refetch: (state, action) => {
      state.refetch = action.payload;
    },
  },
});

export const {
  setFeedbacks,
  setFeedbackDetails,
  setFeedbackQuestions,
  refetch,
} = feedbackSlice.actions;

export const getUsersFeedbacks = (setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/user/feedback/admin/get/feedbacks/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setFeedbacks(data.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const getUserFeedbackDetails = (id, setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/user/feedback/admin/feedback-datails/${id}/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setFeedbackDetails(data.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const removeFeedback = (id, setLoading) => async (dispatch) => {
  try {
    dispatch(refetch(false));
    const url = `${BASE_URL}/user/feedback/admin/delete/${id}/v1`;
    const { data } = await axios.delete(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    toast.success("Feedback deleted successfully", {
      position: "top-center",
      autoClose: 3000,
    });
    dispatch(refetch(true));
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const createFeedbackQuestionRating =
  (formData, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/create/rating/v1`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });

      toast.success("Feedback question rating created successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const createFeedbackMCQQuestion =
  (formData, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/create/mcq/v1`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback MCQ question created successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const createFeedbackLikeDislikeQuestion =
  (formData, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/create/like/dislike/v1`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback like dislike question created successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const getFeedBackQuestions = (setLoading) => async (dispatch) => {
  try {
    const url = `${BASE_URL}/feedback/get/all/feedback/questions/v1`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("sgtoken"),
      },
    });
    dispatch(setFeedbackQuestions(data.data));
    setLoading(false);
  } catch (error) {
    toast.error(error.response.data.message, {
      position: "top-center",
      autoClose: 3000,
    });
    setLoading(false);
  }
};

export const updateFeedbackRatingQuestion =
  (id, formData, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/update/rating/${id}/v1`;
      const { data } = await axios.put(url, formData, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback rating question updated successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const updateFeedbackMCQQuestion =
  (id, formData, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/update/mcq/${id}/v1`;
      const { data } = await axios.put(url, formData, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback MCQ question updated successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const updateFeedbackLikeDislikeQuestion =
  (id, formData, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/update/like/dislike/${id}/v1`;
      const { data } = await axios.put(url, formData, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback like dislike question updated successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const deleteFeedbackQuestionRating =
  (id, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/delete/rating/${id}/v1`;
      const { data } = await axios.delete(url, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback rating question deleted successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const deleteFeedbackMCQQuestion =
  (id, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/delete/mcq/${id}/v1`;
      const { data } = await axios.delete(url, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback MCQ question deleted successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export const deleteFeedbackLikeDislikeQuestion =
  (id, setLoading) => async (dispatch) => {
    try {
      dispatch(refetch(false));
      const url = `${BASE_URL}/feedback/delete/like/dislike/${id}/v1`;
      const { data } = await axios.delete(url, {
        headers: {
          Authorization: localStorage.getItem("sgtoken"),
        },
      });
      toast.success("Feedback like dislike question deleted successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      dispatch(refetch(true));
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

export default feedbackSlice.reducer;
